import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { SurveysAccessLayout } from 'pages/surveys/layout/SurveysAccessLayout'
import { SurveysPageLayout } from 'pages/surveys/layout/SurveysPageLayout'
import { SurveyIdLayout } from 'pages/surveys/layout/SurveyIdLayout'
import { SurveysPage } from 'pages/surveys/ui/SurveysPage'
import { CreateSurvey } from 'pages/surveys/pages/create/CreateSurvey'
import { EditSurvey } from 'pages/surveys/pages/edit/EditSurvey'
import { ViewRouter } from 'pages/surveys/pages/view'
import { SurveysRoutes } from './type'

export const SurveysRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<SurveysAccessLayout />}>
        <Route element={<SurveysPageLayout />}>
          <Route path={'/'} element={<SurveysPage />} />
          <Route path={`${SurveysRoutes.create}`} element={<CreateSurvey />} />
          <Route element={<SurveyIdLayout />}>
            <Route path={`${SurveysRoutes.edit}/:id`} element={<EditSurvey />} />
            <Route path={`${SurveysRoutes.view}/:id`} element={<ViewRouter />} />
          </Route>
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
